import type { SampleDiagnosis } from '../../Model/OrderWizard/OrderWizardDraft.ts'
import { readSequenceHead } from '../../Util/orderSettingDetection/sequenceHead.ts'
import { normalizePrimerRegistry } from '../../Util/orderSettingDetection/primerRegistry.ts'
import { diagnoseSamplePrimers } from '../../Util/orderSettingDetection/primerDiagnosis.ts'
import type { RegistryRow } from './discovery.ts'

/** Must stay free of DOM, store and path-alias imports: it runs inside the detection worker. */

export type DiagnoseRequest = {
  groups: { key: string; forward: Blob; reverse?: Blob; primers: { forward: string; reverse: string } }[]
  registryRows: RegistryRow[] | null
}

export type DiagnoseResult = { diagnoses: { key: string; diagnosis: SampleDiagnosis }[] }

export const runDiagnosis = async (request: DiagnoseRequest): Promise<DiagnoseResult> => {
  const registry = normalizePrimerRegistry(request.registryRows ?? [])
  const diagnoses: DiagnoseResult['diagnoses'] = []
  for (const group of request.groups) {
    const files = await Promise.all(
      [group.forward, group.reverse].filter((blob): blob is Blob => !!blob).map((blob) => readSequenceHead(blob))
    )
    const result = diagnoseSamplePrimers(files, group.primers, registry)
    diagnoses.push({
      key: group.key,
      diagnosis: { diagnosis: result.diagnosis, reason: result.reason }
    })
  }
  return { diagnoses }
}
